import { ICalltracking, INewbuildingDynamicCalltracking } from '../../../types';
import { pathOr } from 'ramda';

export const prepareCalltracking = (data?: INewbuildingDynamicCalltracking | null): ICalltracking => {
  return {
    siteBlockId: pathOr(null, ['siteBlockId'], data),
  };
};
